// extracted by mini-css-extract-plugin
export default {"header":"header_header__N3lue","layout":"header_layout__+Yqcc","logo":"header_logo__5Tbvz","nav":"header_nav__NTird","navLink":"header_navLink__3MOU-"};